import { combineReducers } from "@reduxjs/toolkit";

import accountReducer, { STATE_KEY as ACCOUNT_STATE_KEY } from "../slices/accountSlice";
import moduleCacheReducer from "redux/slices/modulesCacheSlice";
import associatedSkillsReducer from "../slices/associatedSkills/associatedSkillsSlice";
import artifactDetailsReducer from "../slices/artifactDetails/artifactDetailsSlice";
import artifactAISkillSelectionsReducer from "../slices/artifactAISkillSelections/artifactAISkillSelections";
import aiHelperProgressReducer from "../slices/aiHelperToolProgress/aiHelperProgressSlice";

export default combineReducers({
  [ACCOUNT_STATE_KEY]: accountReducer,
  modulesCache: moduleCacheReducer,
  associatedSkills: associatedSkillsReducer,
  artifactDetails: artifactDetailsReducer,
  artifactAISkillSelections: artifactAISkillSelectionsReducer,
  aiHelperProgress: aiHelperProgressReducer,
});
